import { useLoadingPage } from 'shared/hooks/useLoadingPage';

export const LoadingPageFallback = () => {
    useLoadingPage(true);

    return null;
};
